"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
// ? Dialog 처럼 보이지만 실제 Dialog가 아님
// ! 부모 엘리먼트가 다이얼로그가 아님 && open일 때 -> document.body.style.overflow = 'hidden' 필요
const react_1 = require("react");
const react_dom_1 = require("react-dom");
const react_daum_postcode_1 = require("react-daum-postcode");
const webview_app_1 = require("@/webview_app");
const functions_1 = require("@/common/functions");
const Backdrop_1 = __importDefault(require("@mui/material/Backdrop"));
const _1 = require(".");
function default_1({ open, closeDialog, onSelectDaumPostcode, maxWidth768, }) {
    (0, webview_app_1.useAABBDialogClose)({ open, closeDialog, dialogName: 'search-daum-postcode' });
    (0, functions_1.useIOSDialogCloseScrollBack)(open);
    const [daumPostcodeContainer, setDaumPostcodeContainer] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        // ! const isAlreadyHidden = document.body.style.overflow === 'hidden';
        if (open) {
            // ! if (!isAlreadyHidden) document.body.style.overflow = 'hidden';
            setDaumPostcodeContainer(document.querySelector('.daum_postcode'));
            return () => {
                // ! if (!isAlreadyHidden) document.body.removeAttribute('style');
                setDaumPostcodeContainer(undefined);
            };
        }
    }, [open]);
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(Backdrop_1.default, { open: open, onClick: closeDialog, sx: { zIndex: 50 } }), (0, jsx_runtime_1.jsx)(react_daum_postcode_1.DaumPostcodeEmbed, { className: "daum_postcode", onComplete: onSelectDaumPostcode, autoClose: false, style: {
                    position: 'fixed',
                    inset: 0,
                    width: maxWidth768 ? '100%' : '430px',
                    height: maxWidth768 ? '100%' : '60vh',
                    paddingTop: '56px',
                    margin: 'auto',
                    visibility: open ? 'visible' : 'hidden',
                    opacity: open ? 1 : 0,
                    transition: 'opacity 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms',
                    boxShadow: '0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12)',
                    zIndex: 100,
                } }), daumPostcodeContainer &&
                (0, react_dom_1.createPortal)((0, jsx_runtime_1.jsx)("div", Object.assign({ css: { position: 'absolute', top: 0, width: '100%' } }, { children: (0, jsx_runtime_1.jsx)(_1.SearchAddressHeader, { closeDialog: closeDialog }) })), daumPostcodeContainer)] }));
}
exports.default = default_1;
